import { fahrrad, fahrzeug, flugzeug, hubschrauber, kraftrad, person, } from "./symbole";
function applyProps(element, props) {
    return element.attr("fill", props === null || props === void 0 ? void 0 : props.fill);
}
function withProps(render) {
    return (svg, props) => applyProps(render(svg), props);
}
function singleShape(render) {
    return {
        render: withProps(render),
        clipPath: render,
    };
}
function symbolShape(symbol) {
    return {
        size: symbol.size,
        render: (svg, props) => symbol.render(svg, props),
    };
}
const fahrzeugGrundzeichen = {
    size: fahrzeug.size,
    render: (svg, props) => fahrzeug.render(svg, props),
    clipPath: fahrzeug.render,
    paintableArea: [[0, 0], fahrzeug.size],
    einheitAnchor: [37.5, 4.5],
    accepts: [
        "einheit",
        "verwaltungsstufe",
        "fachaufgabe",
        "symbol",
        "organisation",
    ],
    padding: [15, 20, 10],
    textPadding: [15, 10, 10],
};
export const grundzeichen = [
    {
        id: "ohne",
        label: "Kein Grundzeichen",
        size: [45, 45],
        accepts: ["symbol"],
        render: (svg) => svg.g(),
    },
    Object.assign({ id: "taktische-formation", label: "Taktische Formation", size: [75, 45], accepts: [
            "einheit",
            "verwaltungsstufe",
            "fachaufgabe",
            "symbol",
            "organisation",
        ], padding: [10, 20], textPadding: [10, 10] }, singleShape((svg) => svg.path("M1,1 H74 V44 H1 Z"))),
    {
        id: "befehlsstelle",
        label: "Befehlsstelle",
        size: [75, 55],
        render: withProps((svg) => svg.path("M1,55 V1 H74 V44 H1")),
        clipPath: (svg) => svg.path("M1,1 H74 V44 H1 Z"),
        paintableArea: [
            [0, 0],
            [75, 45],
        ],
        padding: [10, 20],
        textPadding: [10, 10],
        accepts: [
            "einheit",
            "verwaltungsstufe",
            "fachaufgabe",
            "symbol",
            "organisation",
        ],
    },
    Object.assign(Object.assign({ id: "stelle", label: "Stelle, Einrichtung", size: [45, 45] }, singleShape((svg) => svg.circle([22.5, 22.5], 21.5))), { accepts: ["fachaufgabe", "symbol", "organisation"], padding: [10, 10], textPadding: [10, 5] }),
    {
        id: "ortsfeste-stelle",
        label: "Stelle, Einrichtung (ortsfest)",
        size: [46, 47.5],
        render: (svg, props) => svg
            .g()
            .push(applyProps(svg.circle([23, 25], 21.5), props))
            .push(svg.path("M.5,8 L23,1 L45.5,8")),
        clipPath: (svg) => svg.circle([23, 25], 21.5),
        accepts: ["fachaufgabe", "symbol", "organisation"],
        paintableArea: [
            [1.5, 3.5],
            [44.5, 46.5],
        ],
        padding: [10, 10],
        textPadding: [10, 5],
    },
    {
        id: "person",
        label: "Person",
        size: person.size,
        render: withProps(person.render),
        clipPath: (svg) => person.render(svg),
        accepts: [
            "einheit",
            "verwaltungsstufe",
            "fachaufgabe",
            "funktion",
            "symbol",
            "organisation",
        ],
        padding: [15, 15],
        textPadding: [10, 12],
    },
    {
        id: "gebaeude",
        label: "Gebäude",
        size: [75, 45],
        render: (svg, props) => svg
            .g()
            .push(svg.path("M1,10 H74 V44 H1 Z").attr("fill", props === null || props === void 0 ? void 0 : props.fill))
            .push(svg.path("M1,10 L37.5,1 L74,10")),
        clipPath: (svg) => svg.path("M1,10 H74 V44 H1 Z"),
        paintableArea: [
            [0, 10],
            [75, 45],
        ],
        accepts: ["fachaufgabe", "symbol", "organisation"],
        padding: [10, 20],
        textPadding: [10, 10],
    },
    Object.assign({ id: "fahrzeug", label: "Fahrzeug" }, fahrzeugGrundzeichen),
    Object.assign(Object.assign({ id: "kraftfahrzeug-landgebunden", label: "Kraftfahrzeug landgebunden" }, fahrzeugGrundzeichen), { size: [75, 55], render: (svg, props) => svg
            .g()
            .push(applyProps(fahrzeug.render(svg), props))
            .push(svg.circle([10, 49], 5))
            .push(svg.circle([65, 49], 5)) }),
    Object.assign(Object.assign({ id: "kraftfahrzeug-gelaendegaengig", label: "Kraftfahrzeug geländegängig oder geländefähig" }, fahrzeugGrundzeichen), { size: [75, 55], render: (svg, props) => svg
            .g()
            .push(applyProps(fahrzeug.render(svg), props))
            .push(svg.circle([10, 49], 5))
            .push(svg.circle([37.5, 49], 5))
            .push(svg.circle([65, 49], 5)) }),
    {
        id: "wechsellader",
        label: "Wechsellader",
        size: [75, 55],
        render: (svg, props) => svg
            .g()
            .push(svg.path("M1,1 v43 h73"))
            .push(applyProps(svg.path("M4,1 Q36.5,10 74,1 v40 h-70 Z"), props))
            .push(svg.circle([10, 49], 5))
            .push(svg.circle([65, 49], 5)),
        clipPath: (svg) => svg.path("M4,1 Q36.5,10 73,1 v40 h-69 Z"),
        paintableArea: [
            [3, 0],
            [75, 42],
        ],
        einheitAnchor: [39.5, 4.5],
        accepts: [
            "einheit",
            "verwaltungsstufe",
            "fachaufgabe",
            "symbol",
            "organisation",
        ],
        padding: [15, 10, 10],
    },
    {
        id: "abrollbehaelter",
        label: "Abrollbehälter, Container",
        size: [75, 45],
        render: (svg, props) => svg
            .g()
            .push(applyProps(svg.path("M7,44 V1 Q35,10 74,1 V44 Z"), props))
            .push(svg.circle([4, 10], 3)),
        clipPath: (svg) => svg.path("M7,44 V1 Q35,10 74,1 V44 Z"),
        paintableArea: [
            [6, 0],
            [75, 45],
        ],
        einheitAnchor: [40, 4.5],
        accepts: ["fachaufgabe", "symbol", "organisation"],
        padding: [15, 10, 10],
    },
    {
        id: "anhaenger",
        label: "Anhänger",
        size: [75, 45],
        render: (svg, props) => applyProps(svg.path("M7,44 V1 Q35,10 74,1 V44 Z M7,10 h-7"), props),
        clipPath: (svg) => svg.path("M7,44 V1 Q35,10 74,1 V44 Z"),
        paintableArea: [
            [6, 0],
            [75, 45],
        ],
        einheitAnchor: [40, 4.5],
        accepts: ["fachaufgabe", "symbol", "organisation"],
        padding: [15, 10, 10],
    },
    Object.assign(Object.assign({ id: "schienenfahrzeug", label: "Schienenfahrzeug" }, fahrzeugGrundzeichen), { size: [75, 55], render: (svg, props) => svg
            .g()
            .push(applyProps(fahrzeug.render(svg), props))
            .push(svg.circle([10, 49], 5))
            .push(svg.circle([22, 49], 5))
            .push(svg.circle([53, 49], 5))
            .push(svg.circle([65, 49], 5)) }),
    Object.assign(Object.assign({ id: "kettenfahrzeug", label: "Kettenfahrzeug" }, fahrzeugGrundzeichen), { size: [75, 55], render: (svg, props) => svg
            .g()
            .push(applyProps(fahrzeug.render(svg), props))
            .push(svg.path("M8 45 a4.5 4.5 0 0 0 0 9 h59 a4.5 4.5 0 0 0 0 -9 Z")) }),
    Object.assign({ id: "fahrrad", label: "Fahrrad", accepts: [] }, symbolShape(fahrrad)),
    Object.assign({ id: "kraftrad", label: "Kraftrad", accepts: [] }, symbolShape(kraftrad)),
    Object.assign({ id: "wasserfahrzeug", label: "Wasserfahrzeug", size: [42, 22], accepts: ["einheit", "verwaltungsstufe", "organisation", "fachaufgabe"] }, singleShape((svg) => svg.path("M1,1 a20 20 0 0 0 40 0 Z"))),
    Object.assign({ id: "flugzeug", label: "Flugzeug", accepts: ["einheit", "verwaltungsstufe", "organisation"] }, symbolShape(flugzeug)),
    Object.assign({ id: "hubschrauber", label: "Hubschrauber", accepts: ["einheit", "verwaltungsstufe", "organisation"] }, symbolShape(hubschrauber)),
    Object.assign(Object.assign({ id: "massnahme", label: "Maßnahme", size: [45, 36], accepts: ["symbol"] }, singleShape((svg) => svg.path("M22.5,1.8 L43.2,35 H1.8 Z").attr("fill", "white"))), { padding: [15, 15, 5] }),
    {
        id: "anlass",
        label: "Anlass, Ereignis",
        size: [45, 36],
        render: (svg) => svg.path("M1,0.6 L22.5,34 L44,0.6").attr("fill", "white"),
        clipPath: (svg) => svg.path("M1,0.6 L22.5,34 L44,0.6 Z"),
        accepts: ["symbol"],
        padding: [5, 15, 15],
    },
    Object.assign(Object.assign({ id: "gefahr", label: "Gefahr", size: [45, 36], accepts: ["symbol"] }, singleShape((svg) => svg.path("M22.5,34 L43.2,1 H1.8 Z").attr("fill", "white"))), { padding: [5, 15, 15] }),
];
